import styled from "styled-components";

export const LegendWrap = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
`;

export const LegendItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  cursor: pointer;
`;

export const LegendColorBox = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-right: 10px;
  background-color: ${(props) => props.color};
  border-radius: 2px;
`;

export const LegendLabel = styled.span`
  margin-right: 10px;
  /* Woman card */
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;
  color: #333333;
`;

export const CheckIcon = styled.svg`
  width: 20px;
  height: 20px;
  /* fill: white; Цвет галочки */
`;
